import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const failures = ["Los cursos de 'negocios online' genéricos no entienden el mercado emocional y artesanal del té.", 'Intentar adivinar los proveedores te hace perder dinero comprando insumos de baja calidad al precio equivocado.', "Calcular los precios 'a ojo' canibaliza tu rentabilidad antes de empezar.", "Postear fotos en Instagram sin una estrategia de 'Experiencia Visual' hace que nadie te escriba."];
  return <section className="py-14 px-6 lg:px-8 bg-white" data-id="element-316">
      <div className="max-w-4xl mx-auto" data-id="element-317">
        <FadeIn data-id="element-318">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-tea-green text-center mb-12" data-id="element-319">
            Por qué lo que intentaste hasta ahora no funcionó
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-320">
          <FadeIn delay={0.2} direction="right" data-id="element-321">
            <p className="text-lg text-tea-charcoal/80 leading-relaxed mb-6" data-id="element-322">
              La mayoría de los emprendimientos fallan porque requieren una
              inversión gigante o son demasiado complejos técnicamente. Intentas
              buscar información en YouTube, pero terminas más confundida que al
              principio:{' '}
              <span className="italic font-medium text-tea-green" data-id="element-323">
                ¿Dónde se compra? ¿Cómo se mezcla? ¿A cuánto se vende?
              </span>
            </p>
            <p className="text-lg text-tea-charcoal/80 leading-relaxed" data-id="element-324">
              Mientras tanto, sigues en piloto automático, viendo cómo otros
              lanzan marcas exitosas en redes sociales mientras tú solo tienes
              una idea que se llena de polvo. El problema no es tu falta de
              talento, es que no tienes una hoja de ruta que elimine las dudas
              de un plumazo.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} direction="left" data-id="element-325">
            <div className="bg-tea-sage/20 rounded-2xl p-8 border border-tea-sage/50" data-id="element-326">
              <h3 className="font-heading text-xl font-bold text-tea-green mb-6" data-id="element-327">
                Los errores comunes:
              </h3>
              <ul className="space-y-4" data-id="element-328">
                {failures.map((failure, index) => <li key={index} className="flex items-start" data-id="element-329">
                    <XCircleIcon className="w-6 h-6 text-red-400/80 mr-3 flex-shrink-0 mt-0.5" data-id="element-330" />
                    <span className="text-tea-charcoal/80 text-base" data-id="element-331">
                      {failure}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}